import {
  FLUSH_DTO_MANUAL,
  FLUSH_PRECIO_MANUAL,
  GET_PRECIOS_PERMISOS_FAIL,
  GET_PRECIOS_PERMISOS_SUCCESS,
  LIMPIAR_PRECIOS,
  SET_DTO_MANUAL,
  SET_PRECIO_MANUAL,
} from '../actions/types.js'

const currency_data = {
  COP: {
    locale: 'es-CO',
    moneda: 'COP',
  },
  BOP: {
    locale: 'es-BO',
    moneda: 'BOP',
  },

  USD: {
    locale: 'en-US',
    moneda: 'USD',
  },
  DOP: {
    locale: 'es-DO',
    moneda: 'DOP',
  },

  GBP: {
    locale: 'en-GB',
    moneda: 'GBP',
  },

  EUR: {
    locale: 'es-ES',
    moneda: 'EUR',
  },
}

const initialState = {
  precio: {},
  permisos: {},
  locale: 'es-ES',
  moneda: 'EUR',
  decimales_significativos: 4,
  decimales_pvp: 3,
  decimales_precios: 3,
}
let locale = ''
let moneda = ''
let decimales_significativos
let decimales_precios
let decimales_pvp

export default function reducer(state = initialState, action) {
  let lista_precios
  switch (action.type) {
    case GET_PRECIOS_PERMISOS_FAIL:
      lista_precios = JSON.parse(JSON.stringify(state.precio))
      // Recorremos el array de articulos seteando en estatus error

      for (let articulo of action.articulos_cantidades) {
        if (!lista_precios[articulo.codigo_articulo]) {
          lista_precios[articulo.codigo_articulo] = {}
        }
        lista_precios[articulo.codigo_articulo][articulo.presentacion] = {
          status: 'error',
        }
      }

      return {
        ...state,
        precio: lista_precios,
        permisos: {},
      }

    case GET_PRECIOS_PERMISOS_SUCCESS:
      lista_precios = JSON.parse(JSON.stringify(state.precio))

      locale = ''
      moneda = ''
      let nuevos_precios = action.payload.v1_b2b_products_pricesamounts_out_list
      let nuevos_permisos = action.payload.permisos

      // Comprobamos si la respuesta es de un solo objeto (WA por cambio en LISA)
      if (typeof nuevos_precios === 'object' && !Array.isArray(nuevos_precios)) {
        nuevos_precios.status = 'iddling'

        lista_precios[nuevos_precios.codigo_articulo][nuevos_precios.presentacion] =
          nuevos_precios.articulo

        let divisa_precio =
          lista_precios[nuevos_precios.codigo_articulo][nuevos_precios.presentacion].divisa_precio

        locale = currency_data[divisa_precio ?? 'EUR'].locale
        moneda = currency_data[divisa_precio ?? 'EUR'].moneda
      } else {
        for (let articulo of nuevos_precios) {
          //Setamos el nuevo status de los articulos
          articulo.status = 'iddling'
          // Eliminamos datos de los decimales y seteamos variables para el estado de precios global
          if (articulo.decimales_significativos) {
            decimales_significativos = articulo.decimales_significativos
            delete articulo.decimales_significativos
          }
          if (articulo.decimales_precios) {
            decimales_precios = articulo.decimales_precios
            delete articulo.decimales_precios
          }
          if (articulo.decimales_pvp) {
            decimales_pvp = articulo.decimales_pvp
            delete articulo.decimales_pvp
          }
          // Creamos una copia del precio_articulo
          let precio_articulo = JSON.parse(JSON.stringify(articulo))
          // Eliminamos los valores inutiles
          if (precio_articulo) {
            if (precio_articulo.codigo_articulo) {
              delete precio_articulo.codigo_articulo
            }
            if (precio_articulo.presentacion) {
              delete precio_articulo.presentacion
            }
          }
          // Seteamos los valores
          if (
            lista_precios[articulo.codigo_articulo] &&
            Object.keys(lista_precios[articulo.codigo_articulo]).length > 0
          ) {
            lista_precios[articulo.codigo_articulo][articulo.presentacion] = precio_articulo
          } else {
            lista_precios[articulo.codigo_articulo] = {}
            lista_precios[articulo.codigo_articulo][articulo.presentacion] = precio_articulo
          }
          if (locale === '' || moneda === '') {
            let divisa_precio =
              lista_precios[articulo.codigo_articulo][articulo.presentacion].divisa_precio
            locale = currency_data[divisa_precio].locale
            moneda = currency_data[divisa_precio].moneda
          }
        }
      }

      return {
        ...state,
        precio: lista_precios,
        permisos: nuevos_permisos,
        locale: locale,
        moneda: moneda,
        decimales_significativos: decimales_significativos || 4,
        decimales_precios: decimales_precios || 3,
        decimales_pvp: decimales_pvp || 3,
      }

    case LIMPIAR_PRECIOS:
      return {
        ...state,
        precio: {},
      }

    case SET_DTO_MANUAL:
      lista_precios = JSON.parse(JSON.stringify(state.precio))

      // Pisamos los datos con los nuevos valores
      lista_precios[action.codigo_articulo][action.presentacion].precio_manual = 'S'
      if (!lista_precios[action.codigo_articulo][action.presentacion].dto_origen) {
        lista_precios[action.codigo_articulo][action.presentacion].dto_origen =
          lista_precios[action.codigo_articulo][action.presentacion].dto_1
      }
      lista_precios[action.codigo_articulo][action.presentacion].dto_1 = action.nuevo_dto

      return {
        ...state,
        precio: lista_precios,
      }

    case SET_PRECIO_MANUAL:
      lista_precios = JSON.parse(JSON.stringify(state.precio))

      // Pisamos los datos con los nuevos valores
      lista_precios[action.codigo_articulo][action.presentacion].precio_manual = 'S'
      if (!lista_precios[action.codigo_articulo][action.presentacion].precio_origen) {
        lista_precios[action.codigo_articulo][action.presentacion].precio_origen =
          lista_precios[action.codigo_articulo][action.presentacion].precio_presentacion
      }

      lista_precios[action.codigo_articulo][action.presentacion].precio_presentacion =
        action.nuevo_precio

      return {
        ...state,
        precio: lista_precios,
      }

    case FLUSH_PRECIO_MANUAL:
      lista_precios = JSON.parse(JSON.stringify(state.precio))

      // Pisamos los datos con los nuevos valores
      if (lista_precios[action.codigo_articulo][action.presentacion].precio_manual === 'S') {
        if (
          lista_precios[action.codigo_articulo][action.presentacion].precio_origen &&
          !lista_precios[action.codigo_articulo][action.presentacion].dto_origen
        ) {
          lista_precios[action.codigo_articulo][action.presentacion].precio_manual = 'N'
        }
        let precio_recuperado =
          lista_precios[action.codigo_articulo][action.presentacion].precio_origen
        lista_precios[action.codigo_articulo][action.presentacion].precio_presentacion =
          precio_recuperado

        delete lista_precios[action.codigo_articulo][action.presentacion].precio_origen
      }
      return {
        ...state,
        precio: lista_precios,
      }

    case FLUSH_DTO_MANUAL:
      lista_precios = JSON.parse(JSON.stringify(state.precio))

      // Pisamos los datos con los nuevos valores
      if (lista_precios[action.codigo_articulo][action.presentacion].precio_manual === 'S') {
        if (
          lista_precios[action.codigo_articulo][action.presentacion].dto_origen &&
          !lista_precios[action.codigo_articulo][action.presentacion].precio_origen
        ) {
          lista_precios[action.codigo_articulo][action.presentacion].precio_manual = 'N'
        }
        let dto_recuperado = lista_precios[action.codigo_articulo][action.presentacion].dto_origen
        lista_precios[action.codigo_articulo][action.presentacion].dto_4 = dto_recuperado

        delete lista_precios[action.codigo_articulo][action.presentacion].dto_origen
      }
      return {
        ...state,
        precio: lista_precios,
      }

    default:
      return state
  }
}
